import React from "react";

import Layout from "../Layout";
import HeaderUploadStatus from "./HeaderUploadStatus";
import ListUploadStatus from "./ListUploadStatus";

const UploadStatus = () => (
  <Layout>
    <HeaderUploadStatus />
    <ListUploadStatus />
  </Layout>
);

UploadStatus.propTypes = {};

UploadStatus.defaultProps = {};

export default UploadStatus;
